import { render, staticRenderFns } from "./BaseTKInfoModal.vue?vue&type=template&id=306c40b3&scoped=true&"
import script from "./BaseTKInfoModal.vue?vue&type=script&lang=ts&"
export * from "./BaseTKInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTKInfoModal.vue?vue&type=style&index=0&id=306c40b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306c40b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VExpansionPanels,VIcon,VList,VListItem,VListItemTitle,VMenu})
